/*
  Bâan Kumlaï — moteur du constructeur de pack 3 / 5 / 7 joncs.
  Utilisé par la page /pages/pack-kumlai (section bk-pack-builder) et par le panneau
  ouvert depuis les fiches produit (snippet bk-packs-fiche), qui charge la section
  par ?section_id=bk-pack-builder puis appelle BKPack.monter(conteneur, { modal: true, params }).
*/
window.BKPack = window.BKPack || {};
window.BKPack.monter = function (conteneur, opts) {
  // Remise par pack. DOIT correspondre aux remises automatiques Shopify.
  // Taux exacts des remises Shopify (4 décimales). Shopify arrondit chaque ligne au centime INFÉRIEUR.
  var TIERS = { 3: 0.0667, 5: 0.1334, 7: 0.2 };
  function remiseLigne(c, pct) { return Math.floor(c * pct + 1e-6); }
  var PACKS = [3, 5, 7];
  var ORDRE_TAILLES = ['S', 'M', 'L', 'XS Enfant'];
  var LIB_TAILLE = { 'XS Enfant': 'XS', 'S': 'S', 'M': 'M', 'L': 'L' };
  var SOUS_TAILLE = { 'XS Enfant': 'Enfant' };
  var FAMILLES = [
    { cle: 'tous', lib: 'Tous' },
    { cle: 'classique', lib: 'Classiques 5 mm' },
    { cle: 'fin', lib: 'Fins 3 mm' },
    { cle: 'torsade', lib: 'Torsadés' },
    { cle: 'tresse', lib: 'Tressés' }
  ];

  opts = opts || {};
  var racine = conteneur.querySelector('.bkp');
  var brut = conteneur.querySelector('script[data-bkp-data]');
  if (!racine || !brut) return;
  var produits;
  try { produits = JSON.parse(brut.textContent); } catch (e) { console.error('bkp: données illisibles', e); return; }

  var parHandle = {};
  produits.forEach(function (p) {
    p.variantes.forEach(function (v) { v.stock = Math.max(0, v.stock); if (!v.dispo) v.stock = 0; });
    parHandle[p.handle] = p;
  });

  function q(sel) { return conteneur.querySelector(sel); }
  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function variante(p, taille) {
    for (var i = 0; i < p.variantes.length; i++) if (p.variantes[i].taille === taille) return p.variantes[i];
    return null;
  }
  function stockDe(p, taille) { var v = variante(p, taille); return v ? v.stock : 0; }

  // Prix de référence : le prix le plus fréquent des joncs classiques (15 € depuis le 23/09/2026).
  var base = (function () {
    var n = {};
    produits.forEach(function (p) { if (p.famille === 'classique') p.variantes.forEach(function (v) { n[v.prix] = (n[v.prix] || 0) + 1; }); });
    var best = 1500, max = 0;
    Object.keys(n).forEach(function (k) { if (n[k] > max) { max = n[k]; best = +k; } });
    return best;
  })();

  var params = opts.params || new URLSearchParams(location.search);
  var etat = {
    pack: PACKS.indexOf(+params.get('pack')) > -1 ? +params.get('pack') : 5,
    taille: null,
    liste: [],
    famille: 'tous'
  };
  var tailleUrl = params.get('taille');
  if (tailleUrl && ORDRE_TAILLES.indexOf(tailleUrl) > -1) etat.taille = tailleUrl;
  var joncUrl = params.get('jonc');
  var joncEnAttente = joncUrl;

  function annoncer(t) { var a = q('[data-annonce]'); a.textContent = ''; setTimeout(function () { a.textContent = t; }, 30); }

  function tailles() {
    return ORDRE_TAILLES.map(function (t) {
      var couleurs = 0, total = 0;
      produits.forEach(function (p) { var s = stockDe(p, t); if (s > 0) { couleurs++; total += s; } });
      return { taille: t, couleurs: couleurs, total: total };
    }).filter(function (x) { return x.couleurs > 0; });
  }

  function compte(handle) { return etat.liste.filter(function (h) { return h === handle; }).length; }

  // etat.pack = pack choisi, c'est-à-dire le MINIMUM de joncs. La cliente peut en ajouter davantage :
  // le tarif reste celui du pack jusqu'au palier suivant (5 puis 7), comme les remises Shopify
  // (« dès 3 / 5 / 7 », non cumulables : Shopify applique la meilleure atteinte).
  function palierDe(n) { var r = 0; PACKS.forEach(function (p) { if (n >= p) r = p; }); return r; }
  function palierActif() { return Math.max(etat.pack, palierDe(etat.liste.length)); }
  function palierSuivant(p) { for (var i = 0; i < PACKS.length; i++) if (PACKS[i] > p) return PACKS[i]; return 0; }

  // Même calcul que Shopify : remise arrondie au centime inférieur jonc par jonc, puis multipliée par la quantité.
  function calcul() {
    var lignes = {}, plein = 0, remise = 0, pct = TIERS[palierActif()];
    etat.liste.forEach(function (h) {
      var v = variante(parHandle[h], etat.taille);
      if (!v) return;
      if (!lignes[v.id]) lignes[v.id] = { v: v, p: parHandle[h], qte: 0 };
      lignes[v.id].qte++;
    });
    Object.keys(lignes).forEach(function (id) {
      var l = lignes[id], m = l.v.prix * l.qte;
      l.plein = m;
      l.remise = remiseLigne(l.v.prix, pct) * l.qte;
      plein += m; remise += l.remise;
    });
    return { lignes: lignes, plein: plein, remise: remise, total: plein - remise };
  }

  function majUrl() {
    if (opts.modal) return;
    var u = new URL(location.href);
    u.searchParams.set('pack', etat.pack);
    if (etat.taille) u.searchParams.set('taille', etat.taille); else u.searchParams.delete('taille');
    u.searchParams.delete('jonc');
    history.replaceState(null, '', u.toString());
  }

  function renduPacks() {
    var z = q('[data-packs]');
    z.innerHTML = '';
    PACKS.forEach(function (n) {
      var pct = TIERS[n];
      var unite = base - remiseLigne(base, pct);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bkp__pack';
      b.setAttribute('aria-pressed', palierActif() === n ? 'true' : 'false');
      b.innerHTML = (n === 7 ? '<span class="bkp__pack-badge">Meilleur prix</span>' : '') +
        '<span class="bkp__pack-n">' + n + ' joncs</span>' +
        '<span class="bkp__pack-prix">Dès ' + euros(unite) + ' le jonc</span>' +
        '<span class="bkp__pack-pct">-' + Math.round(pct * 100) + ' %</span>';
      b.addEventListener('click', function () { choisirPack(n); });
      z.appendChild(b);
    });
  }

  function choisirPack(n) {
    if (n === palierActif()) return;
    etat.pack = n;
    // Pack inférieur au nombre de joncs déjà choisis : on retire le surplus, sinon le palier ne changerait pas.
    if (palierDe(etat.liste.length) > n) {
      var retires = etat.liste.length - n;
      etat.liste = etat.liste.slice(0, n);
      annoncer(retires + (retires > 1 ? ' joncs retirés' : ' jonc retiré') + ' pour passer au pack de ' + n + '.');
    }
    tout();
  }

  function renduTailles() {
    var z = q('[data-tailles]');
    z.innerHTML = '';
    tailles().forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bkp__taille';
      b.setAttribute('aria-pressed', etat.taille === t.taille ? 'true' : 'false');
      var assez = t.total >= etat.pack;
      b.disabled = !assez;
      b.innerHTML = '<strong>' + LIB_TAILLE[t.taille] + (SOUS_TAILLE[t.taille] ? ' <small>' + SOUS_TAILLE[t.taille] + '</small>' : '') + '</strong>' +
        '<span>' + (assez ? t.couleurs + ' coloris' : 'stock insuffisant') + '</span>';
      b.addEventListener('click', function () { choisirTaille(t.taille); });
      z.appendChild(b);
    });
  }

  function choisirTaille(t) {
    if (t === etat.taille) return;
    etat.taille = t;
    // On garde les coloris choisis quand ils existent dans la nouvelle taille.
    var gardes = [], retires = [];
    etat.liste.forEach(function (h) {
      var dejaGardes = gardes.filter(function (x) { return x === h; }).length;
      if (stockDe(parHandle[h], t) > dejaGardes) gardes.push(h); else retires.push(parHandle[h].nom);
    });
    etat.liste = gardes;
    if (joncEnAttente && !etat.liste.length && parHandle[joncEnAttente] && stockDe(parHandle[joncEnAttente], t) > 0) etat.liste.push(joncEnAttente);
    joncEnAttente = null;
    etat.famille = 'tous';
    tout();
    if (retires.length) montrerInfo('Pas disponible en taille ' + LIB_TAILLE[t] + ', retiré de votre pack : ' + retires.filter(function (x, i, a) { return a.indexOf(x) === i; }).join(', ') + '.');
  }

  var infoMsg = '';
  function montrerInfo(t) { infoMsg = t; renduJoncs(); annoncer(t); }

  function ajouter(h) {
    var p = parHandle[h];
    if (compte(h) >= stockDe(p, etat.taille)) return;
    var avant = palierActif();
    etat.liste.push(h);
    infoMsg = '';
    var apres = palierActif();
    if (apres > avant) annoncer(p.nom + ' ajouté. Pack de ' + apres + ' atteint : -' + Math.round(TIERS[apres] * 100) + ' % sur tout le pack.');
    else annoncer(p.nom + ' ajouté. ' + etat.liste.length + (etat.liste.length < etat.pack ? ' sur ' + etat.pack : ' joncs') + '.');
    tout();
  }
  function retirer(h) {
    var i = etat.liste.lastIndexOf(h);
    if (i < 0) return;
    etat.liste.splice(i, 1);
    infoMsg = '';
    annoncer(parHandle[h].nom + ' retiré. ' + etat.liste.length + (etat.liste.length < etat.pack ? ' sur ' + etat.pack : ' joncs') + '.');
    tout();
  }
  function retirerIndex(i) {
    var h = etat.liste[i];
    etat.liste.splice(i, 1);
    infoMsg = '';
    annoncer(parHandle[h].nom + ' retiré.');
    tout();
  }

  function renduJoncs() {
    var z = q('[data-zone-joncs]');
    var aide = q('[data-aide-joncs]');
    z.innerHTML = '';
    if (!etat.taille) {
      aide.textContent = '';
      z.innerHTML = '<div class="bkp__verrou">Choisissez d’abord votre taille : nous n’afficherons que les coloris disponibles dans cette taille.</div>';
      return;
    }
    var nb = etat.liste.length;
    var restant = etat.pack - nb;
    aide.textContent = restant > 0 ? 'Encore ' + restant + ' à choisir. Touchez une photo pour l’ajouter.' : 'Votre pack est complet. Vous pouvez encore en ajouter.';

    // Emplacements 1, 2, 3... (autant que le pack, plus les joncs ajoutés au-delà)
    var slots = document.createElement('div');
    slots.className = 'bkp__slots';
    for (var i = 0; i < Math.max(etat.pack, nb); i++) {
      var h = etat.liste[i];
      var s = document.createElement(h ? 'button' : 'div');
      if (h) {
        s.type = 'button';
        s.className = 'bkp__slot bkp__slot--plein';
        s.setAttribute('aria-label', 'Retirer ' + parHandle[h].nom);
        s.innerHTML = '<img src="' + parHandle[h].img + '" alt="" loading="lazy" width="52" height="52">';
        (function (idx) { s.addEventListener('click', function () { retirerIndex(idx); }); })(i);
      } else {
        s.className = 'bkp__slot';
        s.textContent = i + 1;
      }
      slots.appendChild(s);
    }
    z.appendChild(slots);

    // Pack complet : on indique ce qu'apporte le palier suivant (prix calculé sur le jonc classique).
    if (nb >= etat.pack) {
      var actuel = palierActif(), suivant = palierSuivant(actuel);
      var pal = document.createElement('p');
      pal.className = 'bkp__palier';
      if (suivant) {
        var manque = suivant - nb;
        pal.innerHTML = 'Encore <strong>' + manque + ' jonc' + (manque > 1 ? 's' : '') + '</strong> pour passer au pack de ' + suivant +
          ' : <strong>-' + Math.round(TIERS[suivant] * 100) + ' %</strong> sur tout le pack (dès ' + euros(base - remiseLigne(base, TIERS[suivant])) + ' le jonc au lieu de ' + euros(base - remiseLigne(base, TIERS[actuel])) + ').';
      } else {
        pal.innerHTML = 'Meilleur prix atteint : <strong>-' + Math.round(TIERS[actuel] * 100) + ' %</strong>, y compris sur chaque jonc ajouté.';
      }
      z.appendChild(pal);
    }

    if (infoMsg) {
      var inf = document.createElement('p');
      inf.className = 'bkp__info';
      inf.textContent = infoMsg;
      z.appendChild(inf);
    }

    var dispo = produits.filter(function (p) { return stockDe(p, etat.taille) > 0; });
    var presentes = {};
    dispo.forEach(function (p) { presentes[p.famille] = true; });
    var familles = FAMILLES.filter(function (f) { return f.cle === 'tous' || presentes[f.cle]; });
    if (familles.length > 2) {
      var fz = document.createElement('div');
      fz.className = 'bkp__filtres';
      fz.setAttribute('role', 'group');
      fz.setAttribute('aria-label', 'Filtrer par modèle');
      familles.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bkp__filtre';
        b.textContent = f.lib;
        b.setAttribute('aria-pressed', etat.famille === f.cle ? 'true' : 'false');
        b.addEventListener('click', function () { etat.famille = f.cle; renduJoncs(); });
        fz.appendChild(b);
      });
      z.appendChild(fz);
    }

    var grille = document.createElement('div');
    grille.className = 'bkp__grille';
    var pctCarte = TIERS[palierActif()];
    dispo.filter(function (p) { return etat.famille === 'tous' || p.famille === etat.famille; }).forEach(function (p) {
      var v = variante(p, etat.taille);
      var n = compte(p.handle);
      var max = v.stock;
      var carte = document.createElement('div');
      carte.className = 'bkp__carte' + (n ? ' bkp__carte--choisie' : '');
      var peutAjouter = n < max;
      var html = '';
      html += '<button type="button" class="bkp__carte-img" data-plus ' + (peutAjouter ? '' : 'disabled') + ' aria-label="Ajouter ' + p.nom + '"><img src="' + p.img + '" alt="Jonc bouddhiste ' + p.nom + '" loading="lazy" width="480" height="480"></button>';
      if (n) html += '<span class="bkp__carte-compte" aria-hidden="true">' + n + '</span>';
      html += '<div class="bkp__carte-corps"><p class="bkp__carte-nom">' + p.nom + '</p>';
      html += '<p class="bkp__carte-prix">' + euros(v.prix) + ' <span style="color:#1a7a1a">→ ' + euros(v.prix - remiseLigne(v.prix, pctCarte)) + '</span></p>';
      if (max <= 3) html += '<p class="bkp__carte-stock">Plus que ' + max + ' en ' + LIB_TAILLE[etat.taille] + '</p>';
      if (n) {
        html += '<div class="bkp__qte"><button type="button" data-moins aria-label="Retirer un ' + p.nom + '">−</button><span>' + n + '</span><button type="button" data-plus aria-label="Ajouter un ' + p.nom + '" ' + (peutAjouter ? '' : 'disabled') + '>+</button></div>';
      } else {
        html += '<button type="button" class="bkp__ajout" data-plus ' + (peutAjouter ? '' : 'disabled') + '>' + (peutAjouter ? 'Ajouter' : 'Épuisé') + '</button>';
      }
      html += '</div>';
      carte.innerHTML = html;
      carte.querySelectorAll('[data-plus]').forEach(function (b) { b.addEventListener('click', function () { ajouter(p.handle); }); });
      carte.querySelectorAll('[data-moins]').forEach(function (b) { b.addEventListener('click', function () { retirer(p.handle); }); });
      grille.appendChild(carte);
    });
    z.appendChild(grille);
  }

  function renduRecap() {
    var z = q('[data-recap-corps]');
    var c = calcul();
    if (!etat.liste.length) {
      z.innerHTML = '<p class="bkp__recap-note">Votre pack de ' + etat.pack + ' joncs apparaîtra ici.</p>';
      return;
    }
    var html = '<ul>';
    Object.keys(c.lignes).forEach(function (id) {
      var l = c.lignes[id];
      html += '<li><span>' + l.qte + ' × ' + l.p.nom + ' (' + LIB_TAILLE[etat.taille] + ')</span><span>' + euros(l.plein) + '</span></li>';
    });
    html += '</ul>';
    html += '<div class="bkp__recap-ligne"><span>Prix à l’unité</span><span>' + euros(c.plein) + '</span></div>';
    html += '<div class="bkp__recap-ligne bkp__recap-ligne--eco"><span>Remise pack ' + palierActif() + ' joncs (-' + Math.round(TIERS[palierActif()] * 100) + ' %)</span><span>-' + euros(c.remise) + '</span></div>';
    html += '<div class="bkp__recap-ligne bkp__recap-ligne--total"><span>Total</span><span>' + euros(c.total) + '</span></div>';
    html += '<p class="bkp__recap-note">Remise appliquée automatiquement au paiement. Livraison offerte dès 49 € d’achat en France métropolitaine.</p>';
    z.innerHTML = html;
  }

  function renduBarre() {
    var c = calcul();
    var n = etat.liste.length;
    var complet = n >= etat.pack && !!etat.taille;
    q('[data-barre-compte]').textContent = 'Pack ' + palierActif() + ' joncs' + (etat.taille ? ' · taille ' + LIB_TAILLE[etat.taille] : '') + ' · ' +
      (n < etat.pack ? n + '/' + etat.pack + ' choisis' : n + ' joncs');
    q('[data-barre-total]').textContent = n ? euros(c.total) : '';
    q('[data-barre-plein]').textContent = n ? euros(c.plein) : '';
    q('[data-barre-eco]').textContent = n ? 'Vous économisez ' + euros(c.remise) : 'Choisissez vos joncs';
    var cta = q('[data-cta]');
    cta.disabled = !complet;
    if (!etat.taille) cta.textContent = 'Choisissez la taille';
    else if (!complet) cta.textContent = 'Encore ' + (etat.pack - n);
    else cta.textContent = 'Payer maintenant';
  }

  function tout() { renduPacks(); renduTailles(); renduJoncs(); renduRecap(); renduBarre(); majUrl(); }

  q('[data-cta]').addEventListener('click', function () {
    var c = calcul();
    if (etat.liste.length < etat.pack || !etat.taille) return;
    var cta = this;
    var err = q('[data-erreur]');
    err.hidden = true;
    cta.disabled = true;
    cta.textContent = 'Un instant…';
    var etiquette = 'Pack ' + palierActif() + ' joncs · taille ' + etat.taille;
    var items = Object.keys(c.lignes).map(function (id) {
      return { id: +id, quantity: c.lignes[id].qte, properties: { '_Pack': etiquette } };
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Erreur'); return j; });
    }).then(function () {
      window.location.href = '/checkout';
    }).catch(function (e) {
      err.textContent = 'Impossible d’ajouter le pack : ' + e.message + ' Réessayez ou retirez le jonc concerné.';
      err.hidden = false;
      renduBarre();
    });
  });

  // Guide des tailles : même fenêtre que sur les fiches. Branché ici car les <script> de la section
  // ne s'exécutent pas quand elle est injectée sous une fiche. Sans <dialog>, le lien ouvre l'article du blog.
  var guide = q('[data-bkp-guide]');
  if (guide && typeof guide.showModal === 'function') {
    conteneur.querySelectorAll('[data-bkp-guide-ouvrir]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); guide.showModal(); });
    });
    var fermer = guide.querySelector('[data-bkp-guide-fermer]');
    if (fermer) fermer.addEventListener('click', function () { guide.close(); });
    guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
  }

  // Préremplissage depuis la fiche produit : ?pack=5&taille=M&jonc=jonc-bouddhiste-or
  if (!etat.taille) {
    // Une seule taille possible pour ce jonc : on la choisit pour la cliente.
    if (joncUrl && parHandle[joncUrl]) {
      var t = parHandle[joncUrl].variantes.filter(function (v) { return v.stock > 0; });
      if (t.length === 1) etat.taille = t[0].taille;
    }
  }
  if (etat.taille && !tailles().some(function (x) { return x.taille === etat.taille; })) etat.taille = null;
  if (joncUrl && parHandle[joncUrl] && etat.taille && stockDe(parHandle[joncUrl], etat.taille) > 0) { etat.liste.push(joncUrl); joncEnAttente = null; }

  tout();
};
